var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import axios from 'axios';
import { DefaultRpcs } from 'src/reference-data/default-rpc.list';
import { LocalStorageKeyEnum } from 'src/reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import Logger from 'src/utils/logger.utils';
const getFullList = () => {
    return DefaultRpcs.map((rpc) => {
        return Object.assign(Object.assign({}, rpc), { uri: rpc.uri.endsWith('/')
                ? rpc.uri.substring(0, rpc.uri.length - 1)
                : rpc.uri });
    });
};
const isDefault = (rpc) => {
    return (DefaultRpcs.find((r) => {
        const defaultUri = r.uri.trim().endsWith('/')
            ? r.uri.trim().substring(0, r.uri.trim().length - 1)
            : r.uri.trim();
        const uri = rpc.uri.trim().endsWith('/')
            ? rpc.uri.trim().substring(0, rpc.uri.trim().length - 1)
            : rpc.uri.trim();
        return defaultUri === uri;
    }) !== undefined);
};
const getCustomRpcs = () => __awaiter(void 0, void 0, void 0, function* () {
    const customRpcs = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.RPC_LIST);
    return customRpcs ? customRpcs : [];
});
const addCustomRpc = (rpc) => __awaiter(void 0, void 0, void 0, function* () {
    const savedCustomRpc = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.RPC_LIST);
    const newRpcList = savedCustomRpc ? savedCustomRpc : [];
    newRpcList.push(rpc);
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.RPC_LIST, newRpcList);
});
const deleteCustomRpc = (rpcs, rpc) => {
    const newRpcs = rpcs.filter((r) => rpc.uri !== r.uri);
    saveCustomRpc(newRpcs);
    return newRpcs;
};
const getCurrentRpc = () => __awaiter(void 0, void 0, void 0, function* () {
    let currentRpc = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.CURRENT_RPC);
    currentRpc = currentRpc ? currentRpc : { uri: 'DEFAULT', testnet: false };
    if (currentRpc.uri.endsWith('/'))
        currentRpc = Object.assign(Object.assign({}, currentRpc), { uri: currentRpc.uri.substring(0, currentRpc.uri.length - 1) });
    return currentRpc;
});
/* istanbul ignore next */
const saveCustomRpc = (rpcs) => {
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.RPC_LIST, rpcs);
};
/* istanbul ignore next */
const saveCurrentRpc = (rpc) => {
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.CURRENT_RPC, rpc);
};
const findRpc = (uri) => __awaiter(void 0, void 0, void 0, function* () {
    const list = [...getFullList(), ...(yield RpcUtils.getCustomRpcs())];
    return list.find((e) => e.uri === uri || e.uri === uri + '/' || e.uri + '/' === uri);
});
const checkRpcStatus = (uri) => __awaiter(void 0, void 0, void 0, function* () {
    axios.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        throw new Error('RPC NOK ' + uri + ' ' + error);
    });
    try {
        const result = yield SteemTxUtils.getData('condenser_api.get_config', []);
        if (result === null || result === void 0 ? void 0 : result.STEEM_ADDRESS_PREFIX) {
            return true;
        }
        return false;
        // const result = await axios.get(
        //   ['DEFAULT', 'https://api.steemit.com'].includes(uri)
        //     ? 'https://api.steemit.com'
        //     : `${uri}/health`,
        //   {
        //     timeout: 10000,
        //   },
        // );
        // if (result?.data?.error) {
        //   return false;
        // }
        // return true;
    }
    catch (err) {
        Logger.error('error', err);
        return false;
    }
});
// const test = async () => {
//   const list = [...getFullList(), ...(await RpcUtils.getCustomRpcs())];
//   for (const rpc of list) {
//     try {
//       const start = Date.now();
//       await HiveTxUtils.setRpc(rpc);
//       const res = await HiveTxUtils.getData(
//         'transaction_status_api.find_transaction',
//         { transaction_id: 'f5178d311dd17927d460e8674cabd074df8e24fe' },
//       );
//       const end = Date.now();
//       if (res.status) {
//         // // console.log(`${rpc.uri} responded in ${end - start}ms`);
//       } else {
//         // // console.log(`${rpc.uri} responded without status`);
//       }
//     } catch (e) {
//       // // console.log(`${rpc.uri} had an error`, e);
//     }
//   }
// };
const RpcUtils = {
    getFullList,
    addCustomRpc,
    getCurrentRpc,
    saveCurrentRpc,
    getCustomRpcs,
    isDefault,
    saveCustomRpc,
    deleteCustomRpc,
    findRpc,
    checkRpcStatus,
};
export default RpcUtils;
